import { xBaseTheme } from "@guestsupply/XDL/types";

export default {
    primary: {
        main: "#A32638",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#646569",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#EEEEEE",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#666666",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#D2838E",
        ui9: "#780011",
        ui10: "#979797",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#59595B",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#A32638",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
